import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

export function useIsMobile(): boolean {
  const { isMobile } = useContext(ThemeContext);

  return isMobile;
}
